/**
 * @file   src\validations\authSchema.ts
 * @brief  This file is responsible for defining authentication validation schemas.
 * @date   June, 2024
 * @author ZCO Engineer
 * @copyright (c) 2024, ZCO
 */

import * as yup from 'yup';
import { phoneField } from './phoneSchema';

export const buildSigninSchema = (countryCode?: string) => yup.object({
  custphno: phoneField(countryCode),
});

/** @deprecated Use buildSigninSchema(getActiveCountryCode()) for country-aware validation. */
export const SIGNIN_SCHEMA = buildSigninSchema();
